/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_ToolsInputs */

const en_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Tools`)
};

const fr_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils IA`)
};

const de_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Tools`)
};

const it_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di intelligenza artificiale`)
};

const ru_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструменты искусственного интеллекта`)
};

const es_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de IA`)
};

const zh_cn2_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能工具`)
};

const ja_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIツール`)
};

const hi_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई उपकरण`)
};

const pt_pt2_ai_tools = /** @type {(inputs: Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de IA`)
};

/**
* | output |
* | --- |
* | "AI Tools" |
*
* @param {Ai_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_tools = /** @type {((inputs?: Ai_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ai_tools(inputs)
	if (locale === "de") return de_ai_tools(inputs)
	if (locale === "it") return it_ai_tools(inputs)
	if (locale === "ru") return ru_ai_tools(inputs)
	if (locale === "es") return es_ai_tools(inputs)
	if (locale === "zh-CN") return zh_cn2_ai_tools(inputs)
	if (locale === "ja") return ja_ai_tools(inputs)
	if (locale === "hi") return hi_ai_tools(inputs)
	if (locale === "pt-PT") return pt_pt2_ai_tools(inputs)
	return en_ai_tools(inputs)
});